export const POSE_ROUTES = {
  // POST /api/pose/livekit/ {sessionId, sessionToken} -> {url, token, room}
  LIVEKIT: '/pose/livekit/',
  // POST /api/pose/latency/ {sessionId, sessionToken, summary} -> 204
  LATENCY: '/pose/latency/',
};
